import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEs = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 25,
	height: 17,
	viewBox: "0 0 512 336",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M8.828 335.724h494.345a8.829 8.829 0 0 0 8.828-8.828V9.103a8.829 8.829 0 0 0-8.828-8.828H8.828A8.83 8.83 0 0 0 0 9.103v317.793a8.828 8.828 0 0 0 8.828 8.828z",
				fill: "#C8414B"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#FFD250",
				d: "M0 70.897h512v194.207H0z"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M216.276 168l7.485-33.681c.69-3.102-1.671-6.044-4.849-6.044h-5.272c-3.177 0-5.537 2.942-4.849 6.044L216.276 168z",
				fill: "#C8414B"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#F5F5F5",
				d: "M207.448 150.345h17.655v75.034h-17.655z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#FAB446",
				d: "M203.034 141.517h26.483v8.828h-26.483z"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M185.379 168h44.138v8.828h-44.138zm44.138 35.31l-26.483-8.827v-8.828l26.483 8.828zM83.862 168l7.485-33.681c.69-3.102-1.671-6.044-4.849-6.044h-5.272c-3.177 0-5.537 2.942-4.849 6.044L83.862 168z",
				fill: "#C8414B"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M114.759 141.517a8.829 8.829 0 0 0-8.828 8.828v57.379c0 10.725 10.01 30.897 44.138 30.897s44.138-20.171 44.138-30.897v-57.379a8.829 8.829 0 0 0-8.828-8.828h-70.62z",
				fill: "#F5F5F5"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M150.069 185.655h-44.138v-35.31a8.829 8.829 0 0 1 8.828-8.828h35.31v44.138zm0 0h44.138v22.069c0 12.189-9.88 22.069-22.069 22.069-12.189 0-22.069-9.88-22.069-22.069v-22.069z",
				fill: "#C8414B"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M105.931 185.655h44.138v22.069c0 12.189-9.88 22.069-22.069 22.069-12.189 0-22.069-9.88-22.069-22.069v-22.069z",
				fill: "#FAB446"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M141.241 225.28v-39.625h-8.828v43.693c3.284-.666 6.251-2.12 8.828-4.068zm-17.655 4.068v-43.693h-8.828v39.625c2.578 1.948 5.545 3.402 8.828 4.068z",
				fill: "#C8414B"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#FFB441",
				d: "M114.759 168h26.483v8.828h-26.483z"
			}),
			/* @__PURE__ */ _jsxs("g", {
				fill: "#FAB446",
				children: [/* @__PURE__ */ _jsx("path", { d: "M114.759 150.345h26.483v8.828h-26.483z" }), /* @__PURE__ */ _jsx("path", { d: "M119.172 155.586h17.655v15.992h-17.655z" })]
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#F5F5F5",
				d: "M75.034 150.345h17.655v75.034H75.034z"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M70.621 220.966h26.483v8.828H70.621zm0-79.449h26.483v8.828H70.621z",
				fill: "#FAB446"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#5064AA",
				d: "M66.207 229.793h35.31v8.828h-35.31z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#FAB446",
				d: "M207.448 220.966h26.483v8.828h-26.483z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#5064AA",
				d: "M198.621 229.793h35.31v8.828h-35.31z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#FAB446",
				d: "M123.586 132.69h52.966v8.828h-52.966z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#FFB441",
				d: "M145.655 106.207h8.828v26.483h-8.828z"
			}),
			/* @__PURE__ */ _jsxs("g", {
				fill: "#F5F5F5",
				children: [
					/* @__PURE__ */ _jsx("path", { d: "M141.241 119.448c-7.302 0-13.241-5.94-13.241-13.241 0-7.302 5.94-13.241 13.241-13.241 7.302 0 13.241 5.94 13.241 13.241.001 7.301-5.939 13.241-13.241 13.241zm0-17.655a4.417 4.417 0 0 0-4.414 4.414 4.417 4.417 0 0 0 4.414 4.414 4.416 4.416 0 0 0 4.414-4.414 4.417 4.417 0 0 0-4.414-4.414z" }),
					/* @__PURE__ */ _jsx("path", { d: "M158.897 119.448c-7.302 0-13.241-5.94-13.241-13.241 0-7.302 5.94-13.241 13.241-13.241 7.302 0 13.241 5.94 13.241 13.241 0 7.301-5.94 13.241-13.241 13.241zm0-17.655a4.417 4.417 0 0 0-4.414 4.414 4.417 4.417 0 0 0 4.414 4.414 4.417 4.417 0 0 0 4.414-4.414 4.418 4.418 0 0 0-4.414-4.414z" }),
					/* @__PURE__ */ _jsx("path", { d: "M176.552 128.276c-7.302 0-13.241-5.94-13.241-13.241 0-7.302 5.94-13.241 13.241-13.241 7.302 0 13.241 5.94 13.241 13.241 0 7.301-5.94 13.241-13.241 13.241zm0-17.655a4.417 4.417 0 0 0-4.414 4.414 4.417 4.417 0 0 0 4.414 4.414 4.417 4.417 0 0 0 4.414-4.414 4.417 4.417 0 0 0-4.414-4.414zm-52.966 17.655c-7.302 0-13.241-5.94-13.241-13.241 0-7.302 5.94-13.241 13.241-13.241 7.302 0 13.241 5.94 13.241 13.241.001 7.301-5.939 13.241-13.241 13.241zm0-17.655a4.417 4.417 0 0 0-4.414 4.414 4.417 4.417 0 0 0 4.414 4.414 4.417 4.417 0 0 0 4.414-4.415 4.416 4.416 0 0 0-4.414-4.413z" })
				]
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M176.552 203.31v4.414a4.419 4.419 0 0 1-4.414 4.414 4.419 4.419 0 0 1-4.414-4.414v-4.414h8.828zm8.827-8.827h-26.483v13.241c0 7.302 5.94 13.241 13.241 13.241 7.302 0 13.241-5.94 13.241-13.241v-13.241h.001z",
				fill: "#FAB446"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M172.138 176.828A8.829 8.829 0 0 1 163.31 168v-8.828a8.829 8.829 0 0 1 17.656 0V168a8.829 8.829 0 0 1-8.828 8.828z",
				fill: "#FFA0D2"
			}),
			/* @__PURE__ */ _jsx("circle", {
				fill: "#5064AA",
				cx: 150.069,
				cy: 185.655,
				r: 13.241
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#FAB446",
				d: "M145.655 88.552h8.828v26.483h-8.828z"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M123.586 132.69l-8.828-8.828 5.171-5.171a42.625 42.625 0 0 1 60.28 0l5.171 5.171-8.828 8.828h-52.966z",
				fill: "#C8414B"
			}),
			/* @__PURE__ */ _jsxs("g", {
				transform: "translate(128 119)",
				fill: "#FFD250",
				children: [
					/* @__PURE__ */ _jsx("circle", {
						cx: 22.069,
						cy: 4.862,
						r: 4.414
					}),
					/* @__PURE__ */ _jsx("circle", {
						cx: 4.414,
						cy: 4.862,
						r: 4.414
					}),
					/* @__PURE__ */ _jsx("circle", {
						cx: 39.724,
						cy: 4.862,
						r: 4.414
					})
				]
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M70.621 168h44.138v8.828H70.621zm0 35.31l26.482-8.827v-8.828l-26.482 8.828z",
				fill: "#C8414B"
			})
		]
	})
});
export default SvgEs;
